import { gql, type OperationVariables } from '@apollo/client';
import type ICompanySettings from '@sharedInterfaces/ICompanySettings';
import Company from '@src/Objects/Company';

import GraphQL from '../graphQL';

import { companySettingsGql } from './getCompanySettings';

const query = gql`
mutation setSlackConfig($token: String!, $signingSecret: String!) {
    setSlackConfig(token: $token, signingSecret: $signingSecret) 
    ${companySettingsGql}

},
`;

export default async function setSlackConfig(token: string, signingSecret: string) {
    const variables: OperationVariables = {
        token,
        signingSecret,
    };
    return GraphQL.mutate<ICompanySettings>(query, variables).then((c) => new Company(c));
}
